import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { PortfolioDetailsViewModel } from 'src/app/view-models/portfolio-details.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-portfolio-details',
  templateUrl: './portfolio-details.component.html',
  styleUrls: ['./portfolio-details.component.scss']
})
export class PortfolioDetailsComponent extends BaseComponent<PortfolioDetailsViewModel> implements OnInit {

  constructor(commonService: CommonService, logService: LogHandlerService) {
    super(commonService,logService);
    this.viewModel=new PortfolioDetailsViewModel();
  }

  ngOnInit(): void {
  }

}
